import React, { useState, useEffect } from "react";
import {
  Grid,
  Header,
  Divider,
  Table,
  Button,
  Message,
} from "semantic-ui-react";
import { renderOptionField, renderTextField } from "../formcomponents";
import { Field, reduxForm, FieldArray } from "redux-form";
import WorkFieldArr from "./WorkFieldArr";
import axios from "axios";
import { BaseUrl, BaseUrlInvoice } from "../formcomponents/Constants";
import { userData } from "../store/userData";
import { useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
const validate = (values) => {
  const errors = {};
  if (!values.forWork) {
    errors.forWork = "Required";
  }

  if (values.forWork === "immigiration" || values.forWork === "Labour") {
    if (!values.forWorkType) {
      errors.forWorkType = "Required";
    }
  }

  if (!values.toOrBy) {
    errors.toOrBy = "Required";
  }
  if (!values.workDate) {
    errors.workDate = "Required";
  }

  if (values.workDetailsList) {
    const workListArrError = [];
    values.workDetailsList.forEach((item, index) => {
      const workListErr = {};
      if (!item || !item.item) {
        workListErr.item = "Required";
        workListArrError[index] = workListErr;
      }
      if (!item || !item.description) {
        workListErr.description = "Required";
        workListArrError[index] = workListErr;
      }
      if (!item || !item.quantity) {
        workListErr.quantity = "Required";
        workListArrError[index] = workListErr;
      }
      if (!item || !item.unitPrice) {
        workListErr.unitPrice = "Required";
        workListArrError[index] = workListErr;
      }
      if (!item || !item.category) {
        workListErr.category = "Required";
        workListArrError[index] = workListErr;
      }
      if (!item || !item.purchaseOrSale) {
        workListErr.purchaseOrSale = "Required";
        workListArrError[index] = workListErr;
      }
    });
    if (workListArrError.length) {
      errors.workDetailsList = workListArrError;
    }
  }

  return errors;
};

const CreateNewWork = (props) => {
  const { id, catId } = useParams();
  const navigate = useNavigate();
  const [forOnChangeValue, setforOnChangeValue] = useState("");
  const [laburOrImme, setlaburOrImme] = useState("");
  const [userDetail, setuserDetail] = useState("");
  const [totalAmount, settotalAmount] = useState("");

  const [setshowBtn, setsetshowBtn] = useState(false);
  useEffect(() => {
    const userDectail = userData();
    setuserDetail(userDectail);
    getWorkCatList();

    if (id !== "null") {
      if (userDectail.userRole === 1) {
        setsetshowBtn(true);
      } else {
        setsetshowBtn(false);
      }
      getWorkDetails(id);
    } else {
      setsetshowBtn(true);
    }
  }, [forOnChangeValue, laburOrImme, totalAmount]);
  const { handleSubmit, pristine, submitting, reset } = props;

  const forOption = [
    { text: "Labour", value: "Labour" },
    { text: "Immigiration", value: "immigiration" },
    { text: "MEDICAL", value: "MEDICAL" },
    { text: "HEALTH INSURANCE", value: "HEALTH INSURANCE" },
    { text: "Others", value: "others" },
  ];

  const [itemDesList, setitemDesList] = useState([]);
  const getWorkCatList = async () => {
    await axios
      .post(BaseUrlInvoice + "/accounts/listSSCategory", {
        categoryType: 888,
      })
      .then((res) => {
        console.log("res", res.data);
        const resData = res.data;
        let tempList = [];
        tempList.push(
          { text: "Labour", value: "Labour" },
          { text: "Immigiration", value: "immigiration" },
          { text: "MEDICAL", value: "MEDICAL" },
          { text: "HEALTH INSURANCE", value: "HEALTH INSURANCE" },
          { text: "Others", value: "others" }
        );
        for (let i = 0; i < resData.length; i++) {
          tempList.push({
            text: resData[i].categoryName,
            value: resData[i].categoryName,
          });
        }
        setitemDesList(tempList);
      })
      .catch((error) => console.log(error));
  };

  const labourWorkOption = [
    { text: "NEW FILE OPEN", value: "NEW FILE OPEN" },
    { text: "QUOTA", value: "QUOTA" },
    { text: "JOB OFFER LETTER", value: "JOB OFFER LETTER" },
    { text: "LABOUR INSURANCE", value: "LABOUR INSURANCE" },
    { text: "LABOUR PAYMENT", value: "LABOUR PAYMENT" },
    { text: "RENEWAL CONTRACT", value: "RENEWAL CONTRACT" },
    { text: "NEW CONTRACT SUBMISSION", value: "NEW CONTRACT SUBMISSION" },
    {
      text: "RENEWAL CONTRACT SUBMISSION",
      value: "RENEWAL CONTRACT SUBMISSION",
    },
    { text: "MODIFY PERSON INFORMATION", value: "MODIFY PERSON INFORMATION" },
    { text: "ESTABLISHMENT UPDATION", value: "ESTABLISHMENT UPDATION" },
    { text: "LABOUR CANCELLATION", value: "LABOUR CANCELLATION" },
    { text: "FINE", value: "FINE" },
    { text: "E-SING CARD", value: "E-SING CARD" },
  ];
  const immegrationWorkOption = [
    { text: "NEW ESTABLISHMENT CARD", value: "NEW ESTABLISHMENT CARD" },
    { text: "MODIFY ESTABLISHMENT CARD", value: "MODIFY ESTABLISHMENT CARD" },
    { text: "FILE OPEN", value: "FILE OPEN" },
    { text: "ENTRY PERMIT ", value: "ENTRY PERMIT " }, //cancellation
    { text: "CHANGE STATUS", value: "CHANGE STATUS" },
    { text: "EMIRATES ID", value: "EMIRATES ID" },
    { text: "MEDICAL", value: "MEDICAL" },
    { text: "VISA STAMPING", value: "VISA STAMPING" },
    { text: "VISA CANCELLATION", value: "VISA CANCELLATION" },
    { text: "INSURANCE", value: "INSURANCE" },
  ];

  const otherOptions = [
    { text: "Bank Transfer", value: "Bank Transfer" },
    { text: "Cash", value: "Cash" },
    { text: "Payment Link", value: "Payment Link" },
    { text: "credit card use", value: "credit card use" },
  ];

  const medical = [{ text: "MEDICAL", value: "MEDICAL" }];
  const healthIns = [{ text: "HEALTH INSURANCE", value: "HEALTH INSURANCE" }];
  const getWorkDetails = (id) => {
    console.log("work id", id);
    axios
      .post(BaseUrlInvoice + "accounts/getDailyWorkDetails", {
        dailyWorkId: id,
      })
      .then((res) => {
        // console.log(res.data);
        setInitialValues(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const [error, seterror] = useState(false);
  const setInitialValues = (data) => {
    console.log(data);
    props.initialize({
      dailyWorkId: data.dailyWorkId,
      forWork: data.forWork,
      forWorkOthers: data.forWork,
      forWorkType: data.forWorkType,
      forWorkTypeOthers: data.forWorkType,
      toOrBy: data.toOrBy,
      userId: data.userId,
      workDate: data.workDate,
      workDetailsList: data.workDetailsList,
    });

    settotalAmount(calculateGrandTotal(data.workDetailsList));

    console.log(calculateGrandTotal(data.workDetailsList));
  };

  const calculateGrandTotal = (data) => {
    let grandTotal = 0;

    data.forEach((item) => {
      if (item && typeof item.finalAmount === "number") {
        grandTotal += item.finalAmount;
      }
    });

    return grandTotal;
  };

  useEffect(() => {}, []);
  const sumbitForm = (values) => {
    // console.log(JSON.stringify(values));

    // let forWork, forWorkType;
    // if (values.forWork === "others") {
    //   forWork = values.forWorkOthers;
    // } else {
    //   forWork = values.forWork;
    // }
    // if (values.forWorkType === "others") {
    //   forWorkType = values.forWorkTypeOthers;
    // } else {
    //   forWorkType = values.forWorkType;
    // }

    if (!values.workDetailsList) {
      seterror(true);
    } else {
      const submitObject = {
        dailyWorkId: id,
        workCategory: catId,
        forWork: values.forWork,
        toOrBy: values.toOrBy,
        workDate: values.workDate,
        forWorkType: values.forWorkType,
        userId: userDetail.userId,
        workDetailsList: insertWorkCatId(values.workDetailsList),
      };
      // console.log(JSON.stringify(submitObject, null, 2));
      if (setshowBtn === true && id !== "null") {
        axios
          .post(BaseUrlInvoice + "accounts/editDailyWork", submitObject)
          .then((res) => {
            console.log("res", res.data);
            Swal.fire("Success", "Work Added", "success");
            navigate(`/daily-work-list/${catId}`);
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        console.log("false");
        axios
          .post(BaseUrlInvoice + "accounts/createDailyWork", submitObject)
          .then((res) => {
            console.log(res.data);
            if (res.data) {
              Swal.fire("Success", "Work Added", "success");
              navigate(`/daily-work-list/${catId}`);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
  };

  const insertWorkCatId = (data) => {
    console.log(data);
    let tempArr = [];
    if (data) {
      for (let i = 0; i < data.length; i++) {
        tempArr.push({
          workCategory: catId,
          item: data[i].item,
          description: data[i].description,
          quantity: data[i].quantity,
          unitPrice: data[i].unitPrice,
          category: data[i].category,
          amount: data[i].amount,
          discount: data[i].discount,
          discountPer: data[i].discountPer,
          finalAmount: data[i].finalAmount,
          remarks: data[i].remarks,
        });
      }
    }

    return tempArr;
  };

  const handleExportInvoice = () => {
    const url = `/export-dailywork-invoice/${id}`;

    const a4WidthInPixels = 794; // Approximately 8.27in * 96dpi
    const a4HeightInPixels = 1123; // Approximately 11.69in * 96dpi

    const windowFeatures = `height=${a4HeightInPixels},width=${a4WidthInPixels},top=100,left=100`;
    window.open(url, "_blank", windowFeatures);
    // const windowFeatures = "height=600,width=800,top=100,left=100";
    // window.open(url, "_blank", windowFeatures);
  };
  return (
    <div>
      <Grid.Row>
        <Header dividing size="huge" as="h1">
          {id === "null" ? "Create New Work" : "Work Detail"}
        </Header>

        {id !== "null" && (
          <Button color="purple" onClick={handleExportInvoice}>
            EXPORT INVOICE
          </Button>
        )}
      </Grid.Row>
      <Divider hidden /> <Divider hidden />
      <Grid.Row>
        <Grid columns="five">
          <Grid.Row>
            <Grid.Column>
              <Field
                name="forWork"
                label="For"
                options={itemDesList}
                onChange={(e) => setforOnChangeValue(e)}
                component={renderOptionField}
              />
              {/* {forOnChangeValue === "others" && (
                <Field
                  name="forWorkOthers"
                  label="Mention Here"
                  type="text"
                  component={renderTextField}
                />
              )} */}
            </Grid.Column>
            <Grid.Column>
              <Field
                name="forWorkType"
                label="Select"
                options={
                  forOnChangeValue === "Labour"
                    ? labourWorkOption
                    : forOnChangeValue === "immigiration"
                    ? immegrationWorkOption
                    : forOnChangeValue === "others"
                    ? otherOptions
                    : forOnChangeValue === "MEDICAL"
                    ? medical
                    : forOnChangeValue === "HEALTH INSURANCE"
                    ? healthIns
                    : null
                }
                onChange={(e) => setlaburOrImme(e)}
                component={renderOptionField}
              />

              {laburOrImme === "others" && (
                <Field
                  name="forWorkTypeOthers"
                  label="Mention Here"
                  type="text"
                  component={renderTextField}
                />
              )}
            </Grid.Column>

            <Grid.Column>
              <Field
                name="toOrBy"
                label="To/By"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="workDate"
                label="Date"
                type="date"
                component={renderTextField}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>
      <Divider hidden /> <Divider hidden />
      <Table fixed>
        <Table.Body>
          <Table.Row>
            <Table.Cell className="two wide">
              {" "}
              <label>Company name </label>
            </Table.Cell>
            <Table.Cell className="three wide">
              {" "}
              <label> Item </label>
            </Table.Cell>
            <Table.Cell className="one wide">
              {" "}
              <label>Qty</label>
            </Table.Cell>
            <Table.Cell className="two wide">
              {" "}
              <label>Unit Price</label>
            </Table.Cell>
            <Table.Cell className="two wide">
              {" "}
              <label> Transection</label>
            </Table.Cell>

            <Table.Cell className="two wide">
              {" "}
              <label>Amount</label>
            </Table.Cell>
            <Table.Cell className="two wide">
              {" "}
              <label>Discount</label>
            </Table.Cell>
            <Table.Cell className="two wide">
              {" "}
              <label>Dis(%)</label>
            </Table.Cell>
            <Table.Cell className="two wide">
              {" "}
              <label>Final Amount</label>
            </Table.Cell>
            <Table.Cell className="two wide">
              {" "}
              <label>Remark</label>
            </Table.Cell>
            <Table.Cell className="one wide">
              <label></label>
            </Table.Cell>
          </Table.Row>
          <FieldArray
            name="workDetailsList"
            setshowBtn={setshowBtn}
            totalAmount={totalAmount}
            component={WorkFieldArr}
          />
        </Table.Body>
      </Table>
      <Divider hidden />
      {error === true && (
        <Message negative>
          <Message.Header>Sorry</Message.Header>
          <p>Atleast One Record Must Be Entered</p>
        </Message>
      )}
      <>
        {" "}
        <Button
          type="submit"
          floated="right"
          positive
          disabled={setshowBtn === true ? false : true}
          onClick={handleSubmit((values) =>
            sumbitForm({
              ...values,
            })
          )}
        >
          Save
        </Button>
        <Button
          floated="right"
          negative
          disabled={pristine || submitting}
          onClick={reset}
        >
          Cancel
        </Button>
      </>
    </div>
  );
};

export default reduxForm({
  form: "CreateNewWork",
  validate,
})(CreateNewWork);
